// Build-time configuration (Vite inlines VITE_* values).
export const API_URL = import.meta.env.VITE_API_URL.replace(/\/+$/, '');

/** Fake Telegram launch outside the client: always in dev, opt-in for e2e builds. */
export const MOCK_TELEGRAM = import.meta.env.DEV || import.meta.env.VITE_MOCK_TELEGRAM === 'true';

export const APP_VERSION = __APP_VERSION__;

export const SUPPORT_URL = import.meta.env.VITE_SUPPORT_URL || 'https://t.me/FonusKidsSupport';
export const OFFER_URL = import.meta.env.VITE_OFFER_URL || 'https://ertak.fonuskids.uz/legal/offer';
export const PRIVACY_URL =
  import.meta.env.VITE_PRIVACY_URL || 'https://ertak.fonuskids.uz/legal/privacy';

/** Bot username for share/referral links; empty hides "Share". Never @Fonuskids_bot (CLAUDE.md). */
const botUsername = (import.meta.env.VITE_BOT_USERNAME ?? '').replace(/^@/, '');
export const BOT_USERNAME = botUsername.toLowerCase() === 'fonuskids_bot' ? '' : botUsername;
